//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiChartTimelineVariant, mdiEmailOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  props: {
    notificationData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const optionsLocale = ref(JSON.parse(JSON.stringify(props.notificationData)))

    return {
      optionsLocale,
      icons: { mdiChartTimelineVariant, mdiEmailOutline },
    }
  },
}
